function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Modal, ModalContent, ModalOverlay } from '@chakra-ui/react';
import React from 'react';
import { GiveawayModalContext } from './GiveawayModalContext';
import GiveawayTypeStep from './GiveawayTypeStep';
import { GiveawaySteps } from '@/types/client';
import GiveawayUserEllibility from './GiveawayEligibilityStep';
import GiveawayKeywordStep from './GiveawayKeywordStep';
import GiveawayRandomNumberStep from './GiveawayRandomNumberStep';
import GiveawayActiveStep from './GiveawayActiveStep';
import { AnimatePresence, motion } from 'framer-motion';
import AnimateHeightChange, { DURATION } from './AnimateHeightChange';
var _obj;
var GiveawayStep = (_obj = {}, _define_property(_obj, GiveawaySteps.ELIGIBILITY, /*#__PURE__*/ _jsx(GiveawayUserEllibility, {})), _define_property(_obj, GiveawaySteps.TYPE, /*#__PURE__*/ _jsx(GiveawayTypeStep, {})), _define_property(_obj, GiveawaySteps.KEYWORD_SETTINGS, /*#__PURE__*/ _jsx(GiveawayKeywordStep, {})), _define_property(_obj, GiveawaySteps.RANDOM_NUMBER_SETTINGS, /*#__PURE__*/ _jsx(GiveawayRandomNumberStep, {})), _define_property(_obj, GiveawaySteps.ACTIVE_SETTINGS, /*#__PURE__*/ _jsx(GiveawayActiveStep, {})), _obj);
export default function GiveawayModal(param) {
    var isOpen = param.isOpen, onClose = param.onClose, onComplete = param.onComplete;
    var _React_useState = _sliced_to_array(React.useState(GiveawaySteps.TYPE), 2), step = _React_useState[0], setStep = _React_useState[1];
    var Step = GiveawayStep[step];
    React.useEffect(function() {
        if (!isOpen) {
            setStep(GiveawaySteps.TYPE);
        }
    }, [
        isOpen
    ]);
    return /*#__PURE__*/ _jsxs(Modal, {
        isOpen: isOpen,
        onClose: onClose,
        size: "lg",
        isCentered: true,
        children: [
            /*#__PURE__*/ _jsx(ModalOverlay, {}),
            /*#__PURE__*/ _jsx(ModalContent, {
                backgroundColor: "backgroundPrimary",
                children: /*#__PURE__*/ _jsx(AnimatePresence, {
                    mode: "wait",
                    initial: false,
                    children: /*#__PURE__*/ _jsx(AnimateHeightChange, {
                        children: /*#__PURE__*/ _jsx(GiveawayModalContext.Provider, {
                            value: {
                                isOpen: isOpen,
                                onOpen: onClose,
                                onClose: onClose,
                                setStep: setStep,
                                onComplete: onComplete
                            },
                            children: /*#__PURE__*/ _jsx(motion.div, {
                                initial: {
                                    opacity: 0
                                },
                                animate: {
                                    opacity: 1
                                },
                                exit: {
                                    opacity: 0
                                },
                                transition: {
                                    delay: DURATION
                                },
                                children: Step
                            }, step)
                        })
                    })
                })
            })
        ]
    });
}
